import _ from 'lodash'
import state from '../store/state' // eslint-disable-line no-undef

export default function (agentId) {
  console.log("agents => " , state.agents.data)
  console.log("agentId => " , agentId)
return state.agents.data.find((agent) => agent.id = agentId).login
}




// WEBPACK FOOTER //
// ./src/utils/agentLoginFormatter.js